// https://codesandbox.io/s/d8llw?file=/src/App.js:0-4781
import {useEffect, useRef, useState} from "react"
import {Popover, Transition} from "@headlessui/react"
//import {Float} from "@headlessui-float/react";

interface FlyoutTipProps {
    button: React.ReactNode | ((open: boolean) => React.ReactNode),
    children: React.ReactNode,
    timeoutDuration?: number,
    className?: string
    float?: boolean
}

export const FlyoutTip: React.FC<FlyoutTipProps> = ({children, timeoutDuration = 200, className, float = false, ...props}) => {
    let timeout: any = null; // NodeJS.Timeout

    const buttonRef = useRef<HTMLButtonElement>(null)
    const [openState, setOpenState] = useState<boolean>(false)

    const toggleMenu = (open: boolean) => {
        // log the current open state in React (toggle open state)
        setOpenState((openState) => !openState)
        // toggle the menu by clicking on buttonRef
        buttonRef?.current?.click() // eslint-disable-line
    }

    const button = () => {
        if (props.button && (typeof props.button === 'function')) {
            return props.button(openState);
        } else
            return props.button;
    }
    // Open the menu after a delay of timeoutDuration
    const onHover = (open: boolean, action: string) => {
        // if the modal is currently closed, we need to open it
        // OR
        // if the modal is currently open, we need to close it
        if (
            (!open && !openState && action === "onMouseEnter") ||
            (open && openState && action === "onMouseLeave")
        ) {
            // clear the old timeout, if any
            clearTimeout(timeout)
            // open the modal after a timeout
            timeout = setTimeout(() => toggleMenu(open), timeoutDuration)
        }
        // else: don't click! 😁
    }

    const handleClick = (open: boolean) => {
        setOpenState(!open) // toggle open state in React state
        clearTimeout(timeout) // stop the hover timer if it's running
    }

    const handleClickOutside = (event: MouseEvent) => {
        // @ts-ignore
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
            event.stopPropagation()
        }
    }
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside)

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    })
    return (
        <>
            {float && <Popover>
                {({open}) => (
                    <div onMouseEnter={() => onHover(open, "onMouseEnter")}
                         onMouseLeave={() => onHover(open, "onMouseLeave")}>

                        <Popover className="relative">
                            <Popover.Button ref={buttonRef} onClick={() => handleClick(open)} className={className}>
                                {/*<div onClick={() => handleClick(open)}>*/}
                                {button()}
                                {/*</div>*/}
                            </Popover.Button>
                            <Popover.Panel static anchor="bottom">
                                {children}
                            </Popover.Panel>
                        </Popover>

{/*
                        <Float show={openState}
                            placement="top"
                            arrow
                            enter="transition duration-100 ease-out"
                            enterFrom="transform scale-95 opacity-0"
                            enterTo="transform scale-100 opacity-100"
                            leave="transition duration-75 ease-out"
                            leaveFrom="transform scale-100 opacity-100"
                            leaveTo="transform scale-95 opacity-0"
                        >
                            <Popover.Button ref={buttonRef} onClick={() => handleClick(open)} className={className}>
                                <div onClick={() => handleClick(open)}>
                                {button()}
                                </div>
                            </Popover.Button>
                            <Popover.Panel static className="absolute z-10">
                                {children}
                            </Popover.Panel>
                        </Float>
*/}
                    </div>
                )}
            </Popover>}

            {!float &&
                <Popover>
                    {({open}) => (
                        <div onMouseEnter={() => onHover(open, "onMouseEnter")}
                             onMouseLeave={() => onHover(open, "onMouseLeave")}>
                            <Popover.Button ref={buttonRef} onClick={() => handleClick(open)} className={className}>
                                {/*<div onClick={() => handleClick(open)}>*/}
                                {button()}
                                {/*</div>*/}
                            </Popover.Button>
                            <Transition
                                enter="transition duration-100 ease-out"
                                enterFrom="transform scale-95 opacity-0"
                                enterTo="transform scale-100 opacity-100"
                                leave="transition duration-75 ease-out"
                                leaveFrom="transform scale-100 opacity-100"
                                leaveTo="transform scale-95 opacity-0">
                                <Popover.Panel static className="absolute z-10">
                                    {children}
                                </Popover.Panel>
                            </Transition>
                        </div>
                    )}
                </Popover>
            }
        </>)
}
